<template>
  <div>
    <!-- BEGIN: Modal Toggle -->
    <div class="text-center">
      <a
        class="btn btn-primary"
        @click="openEditModal"
      >
        <PlusIcon class="h-3 w-3 mr-1" />
        เพิ่มเจ้าหน้าที่ CM
      </a>
    </div>
    <ModalLayout v-model="openModalStatus" :headerTitle="`${headTitle}เจ้าหน้าที่ CM : ภายใต้ ${hcm_user.uid}`" @click:save="saveForm" :isDone="isDone" @click:cancel="clearModal" :isDisabledSubmit="cmSelectedList.length == 0">
        <div class="grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
                <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                ค้นหาเจ้าหน้าที่ CM
                </h3>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="hcm-province" class="form-label text-theme-98 sm:w-20">จังหวัด <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            data-test="hcm-province"
                            id="hcm-province"
                            placeholder="กรุณาเลือกจังหวัด"
                            clearable
                            :options="provinceOptions"
                            :reduce="label => label"
                            label="province_name"
                            v-model="validate.province.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.province.$error}"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.province.$error">
                            <div
                                v-for="(error, index) in validate.province.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="hcm-organize" class="form-label text-theme-98 sm:w-20" style="padding-left: 1px;">หน่วยงาน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            data-test="hcm-organize"
                            id="hcm-organize"
                            placeholder="กรุณาเลือกหน่วยงาน"
                            clearable
                            :options="organizeOptions"
                            label="AGC_NAME"
                            :reduce="label => label"
                            v-model="validate.organize.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.organize.$error}"
                            @option:selected="getSubOrganize"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.organize.$error">
                            <div
                                v-for="(error, index) in validate.organize.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="hcm-sub-organize" class="form-label text-theme-98 sm:w-20" style="padding-left: 1px;">หน่วยงานย่อย <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            data-test="hcm-sub-organize"
                            id="hcm-sub-organize"
                            placeholder="กรุณาเลือกหน่วยงานย่อย"
                            clearable
                            :options="subOrganizeOptions"
                            label="ORG_NAME"
                            :reduce="label => label"
                            v-model="validate.sub_organize.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.sub_organize.$error}"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.sub_organize.$error">
                            <div
                                v-for="(error, index) in validate.sub_organize.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 py-5">
                <div class="w-full border-t dark:border-dark-5 border-theme-34"></div>
            </div>
            <div class="col-span-12">
                <div class="overflow-x-auto scrollbar-hidden">
                    <CMListDatatable :filter="filterComputed" @cmSelectedList="updateCmUnderHcm" :cancelModal="cancelData" :reloadTable="reloadTable"/>
                </div>
            </div>
        </div>
    </ModalLayout>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, computed, watch } from 'vue'
import ModalLayout from "@/components/base/custom-modal/CustomModalLayout.vue"
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import Swal from "sweetalert2"
import CMListDatatable from "./CMUnderHCMDatatable.vue"
import { getProvince, getOrganize, getSubOrganizeByOrganize } from "@/utils/get-option-data"
import { useStore } from 'vuex'
import axios from "axios"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const props = defineProps({
    hcm_user: {
        type: Object
    }
})
const emit = defineEmits(["closeModal","openModal"])
const cancelData = ref(false)
const openModalStatus = ref(false)
const userForm = reactive({
    province: null,
    sub_organize: null,
    organize: null

})
const organizeOptions = ref([])
const subOrganizeOptions = ref([])
const provinceOptions = ref([])
const isDone = ref(false)
const headTitle = ref("เพิ่ม")
const cmSelectedList = ref([])
const store = useStore()
const reloadTable = ref(false);

function openEditModal(){
    openModalStatus.value = true
    cancelData.value = false
    reloadTable.value = false
    emit("openModal")
}
const rules = {
    sub_organize: {
        required: helpers.withMessage(`กรุณาเลือกหน่วยงานย่อย`, required)
    },
    province: {
        required: helpers.withMessage(`กรุณาเลือกจังหวัด`, required)
    },
    organize: {
        required: helpers.withMessage(`กรุณาเลือกหน่วยงาน`, required)
    },
}
const validate = useVuelidate(rules, userForm, { $scope: false })
const saveForm = () =>{
    // validate.value.$touch()
    // if(validate.value.$invalid){
    //     return ;
    // }
    try{
        swalCustom.fire({
            text:"ยืนยันบันทึกข้อมูล",
            icon:"info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
        }).then(async (result)=>{
            if (result.isConfirmed) {
                if(cmSelectedList.value.length > 0){
                    let payload = {
                        filter: { uid: { $in: cmSelectedList.value} },
                        update: { 
                            hcm: props.hcm_user
                        }
                    }
                    const token = store.getters["userAuth/getToken"];
                    const config = {
                        url: `${process.env.VUE_APP_BASE_API}user/updateMany`,
                        method: `PUT`,
                        headers:{
                            Authorization: `Bearer ${token}`,
                            "Content-Type": `application/json; charset=utf-8`,
                        },
                        data: payload
                    };
                    const res = await axios(config)
                    .catch(()=>
                        swalCustom.fire({
                            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                            icon: "warning",
                            // timer: 3000, //timeOut for auto-close
                            confirmButtonText: "ปิด",
                        })
                    )
                    if (res.status === 200) {
                        swalCustom.fire({
                            text:"สำเร็จ",
                            icon: 'success',
                            timer: 3000,
                            confirmButtonText: "ปิด",
                        }).then(function () {
                            clearModal(true)
                        });
                    }
                }
            }
        })
    }
    catch(err){
        console.log("Error! ",err);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            // timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
        });
    }
}
function clearModal(isUpdate=null){
    userForm.sub_organize = null
    userForm.province = null
    userForm.organize = null
    isDone.value = false
    validate.value.$reset()
    openModalStatus.value = false
    cancelData.value = true
    reloadTable.value = isUpdate ? true : false
    emit("closeModal",isUpdate)
}


async function getOrganizeOptions(){
    organizeOptions.value = await getOrganize();
}
async function getSubOrganize(val){
    userForm.sub_organize = null
    subOrganizeOptions.value = await getSubOrganizeByOrganize(val)
}

const filterComputed = computed(()=>{
    let result = {
        hcm_linked: 0
    }

    if(userForm.province)
        result.prov = userForm.province._id.province_ID.toString()
    if(userForm.organize)
        result.agc = userForm.organize.AGC_CODE.toString()
    if(userForm.sub_organize)
        result.org = userForm.sub_organize.ORG_CODE.toString()
    return result
})
watch(()=>userForm.organize,(val)=>{
    if(!val){
        userForm.sub_organize = null
    }
})
const updateCmUnderHcm = (evt) =>{
    cmSelectedList.value = evt
}
onMounted(async ()=>{
    await getOrganizeOptions()
    provinceOptions.value = await getProvince()
})

</script>
<style lang="scss">

</style>

